<template>
    <main class="top_btn" v-if="isReturn" @click="returnTop" :style="{bottom: positionBtm + 'px'}">
        <i class='iconfont icon-top'></i>
    </main>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    isReturn: {
      type: Boolean,
      required: true,
      default: false
    },
    positionBtm: {
      type: Number,
      default: 130
    }
  },
  methods: {
    returnTop () {
      this.$emit('returnTop')
    }
  }
}
</script>

<style>
    .top_btn{
        position: fixed;
        bottom:130px;
        right:15px;
        display: block;
        color:#fff;
        width:44px;
        height:44px;
        background: #555;
        opacity: 0.85;
        border-radius: 50%;
        box-sizing: border-box;
        text-align: center;
        line-height: 45px;
        z-index: 99;
    }
    .top_btn .iconfont{
        font-size: 22px;
    }
    .top_btn:hover{
        background-color: rgba(0, 0, 0, 0.1);
    }
</style>
